import { IAdmin } from "../../models/admin";

export const AdminState: IAdmin = {
  auctionsList: {
    data: {},
    isLoading: false,
  },
  auction: {
    data: {},
    isLoading: false,
  },
  updateAuction: {
    isLoading: false,
    isUpdated: false,
  },
  balanceWithdrawList: {
    data: {},
    isLoading: false,
  },
  balanceWithdrawStatusChange: {
    data: {},
    isLoading: false,
    isUpdated: false,
  },
  userData: {
    data: {},
    isLoading: false,
  },
  unprocessedTransactions: {
    data: {},
    isLoading: false,
  },
  transactionsList: {
    data: {},
    isLoading: false,
  },
  refundPayment: {
    isLoading: false,
    errors: [],
  },
  refundedPayment: {
    data: {},
    isLoading: false,
  },
};
